import { darken } from 'polished';
import styled from 'styled-components';
import colors from '~/styles/colors';
import 'rc-collapse/assets/index.css';

export const Container = styled.div`
  max-width: 940px;
  margin: 50px auto;
  flex: 1;

  display: flex;
  flex-direction: column;
  header {
    display: flex;
    justify-content: space-between;
    h1 {
      font-size: 32;
      color: #ffff;
    }

    a {
      padding: 12px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${colors.primary};
      font-weight: bold;
      color: #fff;
      border: 0;
      border-radius: 4px;
      font-size: 16px;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.08, colors.primary)};
      }
      svg {
        margin-right: 10px;
      }
    }
  }
  .rc-collapse {
    flex-direction: column;
    flex: 3;
    border-radius: 0;
    border: 0;
    background-color: transparent;
    margin-top: 1rem;
  }
  .rc-collapse > .rc-collapse-item {
    border-top: 0;
    background-color: white;
    border-radius: 0.4rem;
  }
  .rc-collapse-item + .rc-collapse-item {
    margin-top: 1rem;
  }
  .rc-collapse > .rc-collapse-item > .rc-collapse-header {
    color: ${colors.primary};
    font-size: 2.2rem;
    font-weight: bold;
  }
  .rc-collapse > .rc-collapse-item > .rc-collapse-header .arrow {
    border-left: 0.8rem solid #666;
    border-top: 0.6rem solid transparent;
    border-bottom: 0.6rem solid transparent;
  }
  .rc-collapse > .rc-collapse-item-active > .rc-collapse-header .arrow {
    border-left: 0.6rem solid transparent;
    border-right: 0.6rem solid transparent;
    border-top: 0.8rem solid #666;
  }
  .rc-collapse-content {
    font-size: 1.8rem;
  }
  .rc-collapse-content-active {
    border-top: 0.1rem solid #d9d9d9;
  }
`;

export const PanelItem = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: row;
    button {
      margin-left: 1rem;
      border: 0;
      display: flex;
      align-items: center;
    }
  }
`;

export const Answer = styled.p`
  white-space: pre-wrap;
`;
